import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Attend } from '../Models/attend';

import 'rxjs';
import { Observable } from 'rxjs';


@Injectable()
export class AttendStudentService {

  private headers = new Headers({'Content-Type': 'application/json'});
  private attendsUrl = 'api/attendances/students';  // URL to web api

  constructor(private http: Http) {

  }
  // Check out api, update an already attendance end time
  addCheckOut(attend: Attend) {
    return this.http
      .put(this.attendsUrl, JSON.stringify(attend), {headers: this.headers})
      .map(data => data.json())

  }
  // Check in api, create new attendance with start time
  addCheckIn(attend: Attend){
    return this.http
      .post(this.attendsUrl, JSON.stringify(attend), {headers: this.headers})
      .map(data => data.json())

  }

}



// WEBPACK FOOTER //
// /home/hihoo/ibilling/attendence/public/src/app/Service/attend-student.service.ts